import { render, staticRenderFns } from "./VersionHistoryTable.vue?vue&type=template&id=07980883&scoped=true"
import script from "./VersionHistoryTable.vue?vue&type=script&lang=js"
export * from "./VersionHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./VersionHistoryTable.vue?vue&type=style&index=0&id=07980883&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07980883",
  null
  
)

export default component.exports